document.addEventListener("DOMContentLoaded", async function () {
  const endpoint = "https://ceb-sandbox.myshopify.com/api/2025-07/graphql.json";
  //const accessToken = "d3ebebaacbb687599ca2a9a82aabe318";
  const select = document.getElementById("publication");

  // Clear any default placeholder options
  select.innerHTML = "";

  let allTitles = [];
  let hasNextPage = true;
  let endCursor = null;

  while (hasNextPage && allTitles.length < 150) {
    const query = `
        query ($cursor: String) {
          products(first: 150, after: $cursor) {
            edges {
              cursor
              node {
                id
                title
                tags
              }
            }
            pageInfo {
              hasNextPage
            }
          }
        } 
      `;

    const variables = { cursor: endCursor };

    const response = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        //"X-Shopify-Storefront-Access-Token": accessToken,
      },
      body: JSON.stringify({ query, variables }),
    });

    const data = await response.json();
    const products = data.data.products.edges;

    products.forEach((edge) => {
      const product = edge.node;

      // Add sort order, filtering
      const hasadvanced_order_backstockTag = product.tags.includes(
        "advanced_order_backstock"
      );
      const titleContainsMissing = product.title
        .toLowerCase()
        .includes("missing");
      if (!(hasadvanced_order_backstockTag || titleContainsMissing)) {
        allTitles.push(product);
      }
    });
    hasNextPage = data.data.products.pageInfo.hasNextPage;
    endCursor = products.length ? products[products.length - 1].cursor : null;
  }

  // Add sort order: Sort alphabetically by title
  allTitles.sort((a, b) => a.title.localeCompare(b.title));
  // Add sort order: Append to the dropdown
  allTitles.forEach((product) => {
    const option = document.createElement("option");
    option.value = product.title; // Or product.id if needed
    option.textContent = product.title;
    select.appendChild(option);
  });
});
